export const environment = {
  name: 'dev',
  production: false,
  cms: {
    url: 'https://beyondcmsdev.wpengine.com',
    staticpages: {
      'terms-and-conditions': 2,
      'terms-and-conditions-2022': 1498,
      'genesys-cloud-cx-elearning': 350,
      'beyond-cx': 738,
      'genesys-dx-elearning': 757,
    },
  },
  cookie_domain: '.genesyscsdteng.com', // dot prefix is required!
  docebo: {
    jwt_cookie_name: '_beyond_docebo_jwt',
    url: 'https://learnsandbox.genesys.com',
    client_id: 'mission-control',
    additional_fields: {
      prereqs: 24,
      learning_type: 36,
      company_name: 280,
      salesforce_user_id: 243, // production - used for uat, prod
      salesforce_user_id_override: 243, // only used for local, dev, test
    },
    agent_platform_login_url: 'https://beyondcx.genesys.com/pages/290/agent-platform-dashboard',
    agent_platform_certification_url:
      'https://rise.articulate.com/share/FkBueCTKy-tcta362zE3IK-PmyMjrsG7#/',
  },
  api: {
    kepler: {
      apiAuthorizer: {
        url: 'https://kepler-authorizer-api.genesyscsdteng.com/dev',
        // invokeUrl: 'https://1c48uhvp8c.execute-api.us-east-1.amazonaws.com/dev',
      },
      docebo: {
        url: 'https://kepler-docebo-api.genesyscsdteng.com/dev',
        // invokeUrl: 'https://hglvdqi3k6.execute-api.us-east-1.amazonaws.com/dev',
      },
      credly: {
        url: 'https://kepler-credly-api.genesyscsdteng.com/dev',
      },
    },
  },
  okta: {
    redirectUri: 'explore/login/callback', // localhost doesn't need a hostname component to this URI
    client_id: '0oa1wp87q9eo5pXZT0h8',
    issuer: 'https://genesys.oktapreview.com',
    scopes: ['openid', 'email', 'profile'],
  },
  atlassian: {
    url: 'https://inindca.atlassian.net',
    collector_id: 'e5c530da',
  },
  beyond: {
    home_page: {
      showRecommendedVideos: [1586, 462],
    },
    course_ids_subscription_list: [254, 174, 173, 270],
    subscription_ids: [190, 84, 189, 497, 553, 554, 593],
    genesys_cloud_cx_professional_certification_exam_id: 17089,
    genesys_cloud_cx_developer_certification_exam_id: 17173,
    // 190 - genesysengage , 84 - genesyscloud,  189 - pureconnect, 497 - pointillist
    // 553 - Genesys Cloud Partner Digital Learning Subscription
    // 554 - Genesys Cloud Partner Digital Plus
    // 593 - Genesys Cloud Partner Premier Learning Subscription
    useDoceboTopics: true, // temp - take out if you're reading this after 2024
    agent_platform: {
      training_for_all_CX_roles: [],
      featureFlags: {
        canShowProductInMenu: true,
        canShowProduct: true,
        showAnnouncements: false,
        showAnnouncementsButton: false,
        showCertifications: true,
        showCMSContent: true,
        showContactUs: false,
        showFlexibleLearning: false,
        showHeroBannerButton: true,
        showLearningPaths: false,
        showModal: false,
        showRecommendedFoundationalCourses: false,
        showRecommendedFoundationalHeading: false,
        showRecommendedFoundationalViewAllButton: false,
        showTestimonials: false,
        showTrainingForAllCXRoles: false,
      },
    },
    agent_platform_english: {
      training_for_all_CX_roles: [],
      featureFlags: {
        canShowProductInMenu: false,
        canShowProduct: false,
        showAnnouncements: false,
        showAnnouncementsButton: false,
        showCertifications: true,
        showCMSContent: true,
        showContactUs: false,
        showFlexibleLearning: false,
        showHeroBannerButton: true,
        showLearningPaths: false,
        showModal: false,
        showRecommendedFoundationalCourses: false,
        showRecommendedFoundationalHeading: false,
        showRecommendedFoundationalViewAllButton: false,
        showTestimonials: false,
        showTrainingForAllCXRoles: false,
      },
    },
    agent_platform_spanish: {
      training_for_all_CX_roles: [],
      featureFlags: {
        canShowProductInMenu: false,
        canShowProduct: false,
        showAnnouncements: false,
        showAnnouncementsButton: false,
        showCertifications: true,
        showCMSContent: true,
        showContactUs: false,
        showFlexibleLearning: false,
        showHeroBannerButton: true,
        showLearningPaths: false,
        showModal: false,
        showRecommendedFoundationalCourses: false,
        showRecommendedFoundationalHeading: false,
        showRecommendedFoundationalViewAllButton: false,
        showTestimonials: false,
        showTrainingForAllCXRoles: false,
      },
    },
    agent_platform_portuguese: {
      training_for_all_CX_roles: [],
      featureFlags: {
        canShowProductInMenu: false,
        canShowProduct: false,
        showAnnouncements: false,
        showAnnouncementsButton: false,
        showCertifications: true,
        showCMSContent: true,
        showContactUs: false,
        showFlexibleLearning: false,
        showHeroBannerButton: true,
        showLearningPaths: false,
        showModal: false,
        showRecommendedFoundationalCourses: false,
        showRecommendedFoundationalHeading: false,
        showRecommendedFoundationalViewAllButton: false,
        showTestimonials: false,
        showTrainingForAllCXRoles: false,
      },
    },
    beyondcx: {
      showTestimonials: false,
      showScheduleConsultation: false,
      roiCalculator: {
        showROICalculator: true,
        url: 'https://value.genesys.com/BeyondCX/',
      },
      training_for_all_CX_roles: [],
      featureFlags: {
        canShowProductInMenu: true,
        canShowProduct: true,
        showAnnouncements: false,
        showAnnouncementsButton: false,
        showCertifications: false,
        showCMSContent: true,
        showContactUs: false,
        showFlexibleLearning: false,
        showHeroBannerButton: false,
        showLearningPaths: false,
        showModal: false,
        showRecommendedFoundationalCourses: false,
        showRecommendedFoundationalHeading: false,
        showRecommendedFoundationalViewAllButton: false,
        showTestimonials: false,
        showTrainingForAllCXRoles: false,
      },
    },
    engage: {
      subscription_id: 190,
      foundational_course_ids: [184, 187, 190, 11647],
      related_course_ids: [186, 189, 192],
      training_for_all_CX_roles: [
        'Administrators',
        'Agents',
        'Business Users',
        'Developers',
        'IT',
        'Managers',
        'Supervisors',
      ],
      featureFlags: {
        canShowProductInMenu: false,
        canShowProduct: true,
        showAnnouncements: true,
        showAnnouncementsButton: true,
        showCertifications: true,
        showCMSContent: false,
        showContactUs: true,
        showFlexibleLearning: true,
        showHeroBannerButton: true,
        showLearningPaths: false,
        showModal: true,
        showRecommendedFoundationalCourses: true,
        showRecommendedFoundationalHeading: true,
        showRecommendedFoundationalViewAllButton: true,
        showTestimonials: true,
        showTrainingForAllCXRoles: true,
      },
    },
    pureconnect: {
      subscription_id: 189,
      foundational_course_ids: [344, 345, 346, 11641],
      related_course_ids: [288, 289, 290],
      training_for_all_CX_roles: [],
      featureFlags: {
        canShowProductInMenu: false,
        canShowProduct: true,
        showAnnouncements: false,
        showAnnouncementsButton: false,
        showCertifications: true,
        showCMSContent: false,
        showContactUs: true,
        showFlexibleLearning: true,
        showHeroBannerButton: true,
        showLearningPaths: false,
        showModal: true,
        showRecommendedFoundationalCourses: true,
        showRecommendedFoundationalHeading: false,
        showRecommendedFoundationalViewAllButton: false,
        showTestimonials: true,
        showTrainingForAllCXRoles: true,
      },
    },
    genesys_cloud: {
      subscription_id: 84,
      foundational_course_ids: [135, 140, 143, 17089],
      related_course_ids: [137, 139, 142],
      training_for_all_CX_roles: [
        'Administrators',
        'Agents',
        'Business Users',
        'Developers',
        'IT',
        'Managers',
        'Supervisors',
      ],
      featureFlags: {
        canShowProductInMenu: true,
        canShowProduct: true,
        showAnnouncements: false,
        showAnnouncementsButton: false,
        showCertifications: true,
        showCMSContent: false,
        showContactUs: true,
        showFlexibleLearning: true,
        showHeroBannerButton: true,
        showLearningPaths: true,
        showModal: true,
        showRecommendedFoundationalCourses: true,
        showRecommendedFoundationalHeading: true,
        showRecommendedFoundationalViewAllButton: true,
        showTestimonials: true,
        showTrainingForAllCXRoles: true,
      },
    },
    genesys_cloud_ex: {
      subscription_id: -999,
      foundational_course_ids: [],
      related_course_ids: [],
      training_for_all_CX_roles: ['Administrators', 'Supervisors', 'Managers', 'Agents'],
      featureFlags: {
        canShowProductInMenu: true,
        canShowProduct: true,
        showAnnouncements: false,
        showAnnouncementsButton: false,
        showCertifications: false,
        showCMSContent: false,
        showContactUs: true,
        showFlexibleLearning: false,
        showHeroBannerButton: true,
        showLearningPaths: false,
        showModal: true,
        showRecommendedFoundationalCourses: false,
        showRecommendedFoundationalHeading: true,
        showRecommendedFoundationalViewAllButton: true,
        showTestimonials: true,
        showTrainingForAllCXRoles: true,
      },
    },
    pointillist: {
      subscription_id: 497,
      foundational_course_ids: [17423, 17573, 17574, 17674],
      training_for_all_CX_roles: [
        'Administrators',
        'Agents',
        'Analysts',
        'Business Users',
        'Developers',
        'IT',
        'Managers',
        'Supervisors',
      ],
      featureFlags: {
        canShowProductInMenu: false,
        canShowProduct: true,
        showAnnouncements: false,
        showAnnouncementsButton: false,
        showCertifications: false,
        showCMSContent: false,
        showContactUs: true,
        showFlexibleLearning: true,
        showHeroBannerButton: false,
        showLearningPaths: true,
        showModal: true,
        showRecommendedFoundationalCourses: false,
        showRecommendedFoundationalHeading: true,
        showRecommendedFoundationalViewAllButton: true,
        showTestimonials: false,
        showTrainingForAllCXRoles: false,
        showPointillistDetailHeroBanner: true,
      },
    },
    // 553 - Genesys Cloud Partner Digital Learning Subscription
    // 554 - Genesys Cloud Partner Digital Plus
    // 593 - Genesys Cloud Partner Premier Learning Subscription
    // 597 - Genesys Cloud TRIAL Subscription
    genesys_cloud_partner_digital: {
      subscription_id: 553,
      foundational_course_ids: [],
    },
    genesys_cloud_partner_digital_plus: {
      subscription_id: 554,
      foundational_course_ids: [],
    },
    ai_essentials: {
      subscription_id: 613,
      foundational_course_ids: [],
    },
    genesys_cloud_partner_premier: {
      subscription_id: 593,
      foundational_course_ids: [135, 140, 143, 17089],
      related_course_ids: [137, 139, 142],
      training_for_all_CX_roles: [],
      featureFlags: {
        canShowProductInMenu: false,
        canShowProduct: false,
        showAnnouncements: false,
        showAnnouncementsButton: false,
        showCertifications: true,
        showCMSContent: false,
        showContactUs: true,
        showFlexibleLearning: true,
        showHeroBannerButton: true,
        showLearningPaths: true,
        showModal: true,
        showRecommendedFoundationalCourses: true,
        showRecommendedFoundationalHeading: true,
        showRecommendedFoundationalViewAllButton: true,
        showTestimonials: true,
        showTrainingForAllCXRoles: true,
      },
    },
    genesys_cloud_trial: {
      subscription_id: 597,
      foundational_course_ids: [135, 140, 143, 17089],
      related_course_ids: [137, 139, 142],
      training_for_all_CX_roles: [],
      featureFlags: {
        canShowProductInMenu: false,
        canShowProduct: false,
        showAnnouncements: false,
        showAnnouncementsButton: false,
        showCertifications: true,
        showCMSContent: false,
        showContactUs: true,
        showFlexibleLearning: true,
        showHeroBannerButton: true,
        showLearningPaths: true,
        showModal: true,
        showRecommendedFoundationalCourses: true,
        showRecommendedFoundationalHeading: true,
        showRecommendedFoundationalViewAllButton: true,
        showTestimonials: true,
        showTrainingForAllCXRoles: true,
      },
    },
    featureFlags: {
      showCourseAvailabilityFacet: true,
      showPendo: true,
      showMegaMenuResources: true,
      showVoucher: true,
      showBackToTop: true,
      // New Home page design based on flags starts here
      subscriptionTilesNew: true, // Make true if you want new design.
      homeBannerNew: true, // Make true if you want new design.
      contactSalesForm: true, // Make true if you want new design.
      showHomeVideoSection: false, // Make false if you want to hide video section.
      eloquaFormIsDarkTheme: true, // Make this true if you want the dark theme eloqua form

      showHomePageBannerCarousel: false,
      showTrustedPartner: false,
      showCourseFeature: false,
      showContactSales: true,
      showOktaLoginButton: true,
    },
  },
  pendo: {
    userIdPrefix: 'DEV', // use a prefix in dev so Pendo can filter out these analytics
  },
  beyondRegistration: {
    url: 'https://dev.register.genesyscsdteng.com',
  },
  beyondApi: {
    url: 'https://beyond-api.genesyscsdteng.com/dev',
    beyond_api: 'j6WZVHy39X9rdScbMsmuC6JGLhorr9lfYht1gHj9',
  },
  externalRedirect: {
    urls: [
      'https://beyondcx.genesys.com/pages/290/agent-platform-dashboard',
      'https://beyondcx.genesys.com/pages/301/panel-de-control-de-plataforma-de-agentes',
      'https://beyondcx.genesys.com/pages/302/painel-da-plataforma-de-agentes',
      'https://beyondcx.genesys.com/pages/304/ejentopurattofomudasshubodo',
    ],
  },

  voucherApi: {
    url: 'https://deathstar-api.genesyscsdteng.com/dev',
    deathstar_api: 'xUMiMIlzWJ29wMhkK1O1x13B9LExdghn229iguse',
  },
  register_url: 'https://dlp-email.inindca.com/register',
  search_api: '3cdda4ab-68de-417c-a555-072b5ff31058',
  support_url: 'https://support.education.genesyscsdteng.com/',
};
